// extracted by mini-css-extract-plugin
export default {"group":"SP6CJb1xVIbzpWd40MIX"};